module.exports = __webpack_public_path__ + "static/denver-59f8fc62131474911c7691781ed5b3a0.png";